import React from 'react';
import { SelfReferralForm } from '@/components/self-referral/SelfReferralForm';
import type { SelfReferralFormData } from '@/components/self-referral/types';
import { useTheme } from '@/hooks/useTheme';
import { cn } from '@/utils/cn';

interface DirectPatientInfoStepProps {
  onSubmit: (data: SelfReferralFormData) => void;
  isLoading: boolean;
  error?: string;
  initialData?: Partial<SelfReferralFormData>;
  title?: string;
}

export const DirectPatientInfoStep: React.FC<DirectPatientInfoStepProps> = ({
  onSubmit,
  isLoading,
  error,
  initialData,
  title = "Enter your details to book"
}) => {
  const { isDark } = useTheme();

  return (
    <div className="animate-fade-in">
      <h2 className={cn("text-xl font-semibold mb-6", isDark ? "text-white" : "text-gray-900")}>
        {title}
      </h2>
      <SelfReferralForm
        onSubmit={onSubmit}
        isLoading={isLoading}
        error={error}
        initialData={initialData}
        submitLabel="Continue"
      />
    </div>
  );
};
